/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_Optin_DescriptionInputs */



/**
* | output |
* | --- |
* | "Occasional emails about new features and releases. You can unsubscribe at any time." |
*
* @param {Newsletter_Optin_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const newsletter_optin_description = /** @type {((inputs?: Newsletter_Optin_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Optin_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gelegentliche E-Mails zu neuen Funktionen und Releases. Jederzeit abbestellbar.")
	return /** @type {LocalizedString} */ ("Occasional emails about new features and releases. You can unsubscribe at any time.")
});